import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import listViewModes from './constants/list-view-modes';
import classNames from 'classnames';

import './list-view-mode-switcher.css';

class ListViewModeSwitcher extends PureComponent
{
  handleClickThumbButton = () =>
  {
    const { value, onChange, isDisabled } = this.props;

    if (isDisabled)
    {
      return;
    }

    if (value === listViewModes.TABLE)
    {
      onChange(listViewModes.THUMB);
    }
  };

  handleClickTableButton = () =>
  {
    const { value, onChange, isDisabled } = this.props;

    if (isDisabled)
    {
      return;
    }

    if (value === listViewModes.THUMB)
    {
      onChange(listViewModes.TABLE);
    }
  };

  render()
  {
    const { value, isDisabled } = this.props;

    const containerClass = classNames({
      'resource-dialog__list-view-switcher-container': true,
      'resource-dialog__list-view-switcher-container_disabled': isDisabled
    });

    const thumbViewButtonClass = classNames({
      'resource-dialog__thumb-view-mode-button': true,
      'resource-dialog__thumb-view-mode-button_active': value === listViewModes.THUMB
    });

    const tableViewButtonClass = classNames({
      'resource-dialog__table-view-mode-button': true,
      'resource-dialog__table-view-mode-button_active': value === listViewModes.TABLE
    });

    return (
      <div className={containerClass}>
        <div
          className={thumbViewButtonClass}
          onClick={this.handleClickThumbButton}
          data-test-id="idIRD_ButtonThumbViewMode"
        />
        <div
          className={tableViewButtonClass}
          onClick={this.handleClickTableButton}
          data-test-id="idIRD_ButtonTableViewMode"
        />
      </div>
    );
  }
}


ListViewModeSwitcher.propTypes = {
  value: PropTypes.oneOf(Object.values(listViewModes)).isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
};

ListViewModeSwitcher.defaultProps = {
  isDisabled: false
};

export default ListViewModeSwitcher;